import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { AssigneeModelSchema } from '../../shared/assignee-model.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { RejectReasonSchema } from '../../shared/reject-reason.schema';
import { ReassigneeTypeSchema, refineReassigneeFields } from '../../shared/reassignee-type.schema';
/**
 * Reject Assignment Request Schema
 * POST /api/v2/process-step-assignment/:id/reject
 * Rejects an assignment with a specific reason and optional reassignment
 *
 * When rejectReason is 're-assign', both reAssigneeId and reAssigneeModel
 * are required. The reAssigneeModel discriminates which collection to look
 * the id up in (User / Team / System / ExternalContact). reAssigneeType
 * defaults to 'entity'; when 'suggestion', reAssigneeId is an EntitySuggestion
 * id (also a 24-hex ObjectId) and reAssigneeModel is restricted to System /
 * Team.
 */ export const RejectAssignmentRequestSchema = z.object({
    rejectReason: RejectReasonSchema,
    reAssigneeId: ObjectIdSchema.optional(),
    reAssigneeModel: AssigneeModelSchema.optional(),
    reAssigneeType: ReassigneeTypeSchema.default('entity')
}).superRefine(refineReassigneeFields);
/**
 * Reject Assignment Response Schema
 * Returned on successful assignment rejection
 * Returns void - no response body
 */ export const RejectAssignmentResponseSchema = z.void();
/**
 * Reject Assignment Error Schema
 * Returned when assignment rejection fails
 */ export const RejectAssignmentErrorSchema = BaseErrorSchema;

//# sourceMappingURL=reject-assignment.schema.js.map